import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    const isDark = document.documentElement.classList.contains("dark")
    localStorage.setItem("theme", isDark ? "light" : "dark")
    this.applyTheme()
  }

  applyTheme() {
    const stored = localStorage.getItem("theme")
    document.documentElement.classList.toggle("dark", stored !== "light")
  }
}
